// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicationDataWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ApplicationsForListingResponseDto, ApplicationStatusResponseDto, ListingAlias } from '../..';

interface GetActiveApplicationsParams {
  listingAlias: ListingAlias;
}
interface GetApplicationStatusParams {
  applicationId: string;
  listingAlias: ListingAlias;
}
interface GetArchivedApplicationsParams {
  listingAlias: ListingAlias;
}
interface GetCompletedApplicationsParams {
  listingAlias: ListingAlias;
}
interface GetInProgressApplicationsParams {
  listingAlias: ListingAlias;
}

export const CappsLandlordApplicationDataWebApiHandler_getActiveApplications_Path =
  '/api/web/landlord/v1/applications/getActiveApplications';

export const CappsLandlordApplicationDataWebApiHandler_getActiveApplications = (
  getParams: GetActiveApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetActiveApplicationsParams, never, ApplicationsForListingResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationDataWebApiHandler_getActiveApplications_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_Path =
  '/api/web/landlord/v1/applications/getApplicationStatus';

export const CappsLandlordApplicationDataWebApiHandler_getApplicationStatus = (
  getParams: GetApplicationStatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetApplicationStatusParams, never, ApplicationStatusResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationDataWebApiHandler_getApplicationStatus_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_Path =
  '/api/web/landlord/v1/applications/getArchivedApplications';

export const CappsLandlordApplicationDataWebApiHandler_getArchivedApplications = (
  getParams: GetArchivedApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetArchivedApplicationsParams, never, ApplicationsForListingResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationDataWebApiHandler_getArchivedApplications_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_Path =
  '/api/web/landlord/v1/applications/getCompletedApplications';

export const CappsLandlordApplicationDataWebApiHandler_getCompletedApplications = (
  getParams: GetCompletedApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetCompletedApplicationsParams, never, ApplicationsForListingResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationDataWebApiHandler_getCompletedApplications_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordApplicationDataWebApiHandler_getInProgressApplications_Path =
  '/api/web/landlord/v1/applications/getInProgressApplications';

export const CappsLandlordApplicationDataWebApiHandler_getInProgressApplications = (
  getParams: GetInProgressApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetInProgressApplicationsParams, never, ApplicationsForListingResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationDataWebApiHandler_getInProgressApplications_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
